import React, { useEffect } from 'react';
import Button from '@atlaskit/button/standard-button';
import IconError from '@atlaskit/icon/glyph/cross-circle';
import { ErrorText, ErrorTitle, ErrorWrapper } from '../../styled/Error';
import { profileCardRendered } from '../../util/analytics';
var ErrorMessage = function ErrorMessage(props) {
  var errorType = props.errorType || {
    reason: 'default'
  };
  var errorReason = errorType.reason;
  var fireAnalytics = props.fireAnalytics,
    reload = props.reload;
  var hasRetry = !!reload;
  useEffect(function () {
    fireAnalytics(profileCardRendered('user', 'error', {
      hasRetry: hasRetry,
      errorType: errorReason
    }));
  }, [errorReason, fireAnalytics, hasRetry]);
  var errorContent = function errorContent() {
    if (errorReason === 'NotFound') {
      return /*#__PURE__*/React.createElement(ErrorTitle, null, "The user is no longer available for the site");
    }
    return /*#__PURE__*/React.createElement(ErrorTitle, null, "Oops, looks like we\u2019re having issues", /*#__PURE__*/React.createElement("br", null), reload && /*#__PURE__*/React.createElement(ErrorText, null, "Try again and we\u2019ll give it another shot"));
  };
  return /*#__PURE__*/React.createElement(ErrorWrapper, {
    "data-testid": "profilecard-error"
  }, /*#__PURE__*/React.createElement(IconError, {
    label: "icon error",
    size: "xlarge"
  }), errorContent(), reload && /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: reload
  }, "Try again"));
};
export default ErrorMessage;